import React, { useState } from "react";
import axios from "axios";
import { Package, Truck, CheckCircle, XCircle } from "lucide-react";

const statusConfig = {
  Confirmed: { icon: Package, color: "text-blue-600 bg-blue-100" },
  "In Transit": { icon: Truck, color: "text-yellow-600 bg-yellow-100" },
  Delivered: { icon: CheckCircle, color: "text-green-600 bg-green-100" },
  Cancelled: { icon: XCircle, color: "text-red-600 bg-red-100" },
  "Failed Delivery": { icon: XCircle, color: "text-red-600 bg-red-100" },
};

export default function TrackOrder() {
  const [orderNumber, setOrderNumber] = useState("");
  const [order, setOrder] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const BASE_URL =
    process.env.REACT_APP_API_BASE_URL || "http://localhost:5000";

  const handleTrackOrder = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    setOrder(null);

    try {
      const { data } = await axios.get(
        `${BASE_URL}/api/orders/track/${orderNumber}`,
        { withCredentials: true }
      );

      // Normalize status
      let normalizedStatus = data.status;
      if (["Pending", "Processing"].includes(normalizedStatus)) {
        normalizedStatus = "Confirmed";
      }

      setOrder({ ...data, status: normalizedStatus });
    } catch (err) {
      setError(
        err.response?.data?.error || "Unable to retrieve order details."
      );
    } finally {
      setLoading(false);
    }
  };

  const renderStatusCard = () => {
    if (!order) return null;
    const config = statusConfig[order.status] || statusConfig["Confirmed"];
    const Icon = config.icon;

    return (
      <div className="bg-white shadow-lg rounded-2xl p-6 mt-6 max-w-md mx-auto text-center">
        {/* Order Number */}
        <h2 className="text-lg font-semibold text-gray-800 mb-6">
          Order #{order.orderNumber}
        </h2>

        {/* Circle with Icon */}
        <div
          className={`w-28 h-28 mx-auto flex items-center justify-center rounded-full ${config.color}`}
        >
          <Icon size={56} />
        </div>

        {/* Status Text */}
        <p className="mt-6 text-xl font-bold text-gray-700">{order.status}</p>
      </div>
    );
  };

  return (
    <div className="p-6 max-w-xl mx-auto">
      <h1 className="text-2xl font-bold mb-4">Track Your Order</h1>

      {/* Input Form */}
      <form onSubmit={handleTrackOrder} className="space-y-4">
        <input
          type="text"
          value={orderNumber}
          onChange={(e) => setOrderNumber(e.target.value)}
          placeholder="Enter Order Number"
          className="w-full border px-4 py-2 rounded shadow-sm"
        />
        <button
          type="submit"
          disabled={loading}
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
        >
          {loading ? "Tracking..." : "Track"}
        </button>
      </form>

      {/* Error Message */}
      {error && <p className="text-red-600 mb-4">{error}</p>}

      {/* Status Card */}
      {renderStatusCard()}
    </div>
  );
}
